/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import { Table, Button, Form, Input, message, Popconfirm, Row, Col } from 'antd';
import { DeleteOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';

import UploadModal from './UploadModal';
import { Main } from '../../styled';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { DataService } from '../../../config/dataService/dataService';
import { TableWrapper } from '../../../container/styled';
import { API_ENDPOINT } from '../../../config/config';

function ImportantDocuments() {
  const [documents, setDocuments] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [busy, setBusy] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchDocuments();
    fetchCategories();
  }, [currentPage, pageSize, search]);

  const fetchDocuments = async () => {
    try {
      setBusy(true);
      const response = await DataService.post('/important-docs/query', {
        page: currentPage,
        pageSize,
        search,
      });
      const { data, total, status, message: msg } = response.data;
      if (status) {
        setDocuments(data);
        setTotalRows(total);
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error('Failed to fetch documents');
    } finally {
      setBusy(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await DataService.get('/document-categories');
      const { data, status, message: msg } = response.data;
      if (status) {
        setCategories(data);
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error('Failed to fetch categories');
    }
  };

  const handleUpload = async (values) => {
    try {
      setBusy(true);
      const formData = new FormData();
      formData.append('title', values.title);
      formData.append('description', values.description);
      formData.append('category_id', values.category_id);
      formData.append('document', fileList[0].originFileObj);

      const response = await DataService.post('/important-docs', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      const { status, message: msg } = response.data;
      if (status) {
        message.success(msg);
        setIsModalVisible(false);
        form.resetFields();
        setFileList([]);
        fetchDocuments();
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error('Failed to upload document');
    } finally {
      setBusy(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/important-docs/delete', { id });
      const { status, message: msg } = response.data;
      if (status) {
        message.success(msg);
        fetchDocuments();
      } else {
        message.error(msg);
      }
    } catch (error) {
      message.error('Failed to delete document');
    } finally {
      setBusy(false);
    }
  };

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      key: 'created_by',
      width: '10%',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '10%',
    },
    {
      title: 'File Type',
      dataIndex: 'file_type',
      key: 'file_type',
      width: '7%',
      render: (text) => text?.toUpperCase() || '-'
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 10,
      export: false,
      render: (_, record) => (
        <div className="flex gap-2">
          <Button
            icon={<EyeOutlined />}
            onClick={() => window.open(`${API_ENDPOINT}/${record.file_path}`, '_blank')}
          />
          <Popconfirm
            title="Are you sure you want to delete this document?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              icon={<DeleteOutlined />}
              danger
            />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <>
      <PageHeader className="ninjadash-page-header-main" title="Important Documents" routes={[]} />
      <Main>
        <Row gutter={[16, 16]} className="mb-4">
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Input
                className="w-1/4"
                placeholder="Search documents"
                prefix={<SearchOutlined />}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                allowClear
              />
              <Button
                type="primary"
                onClick={() => setIsModalVisible(true)}
              >
                Upload New Document
              </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <TableWrapper>
              <Table
                rowKey="id"
                loading={busy}
                bordered
                size='middle'
                className='border rounded drop-shadow-sm'
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRows,
                  showSizeChanger: true,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
                dataSource={documents}
                columns={columns}
                scroll={{ x: 'max-content' }}
              />
            </TableWrapper>
          </Col>
        </Row>

        <UploadModal
          visible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false);
            form.resetFields();
            setFileList([]);
          }}
          onFinish={handleUpload}
          form={form}
          fileList={fileList}
          setFileList={setFileList}
          categories={categories}
          loading={busy}
        />
      </Main>
    </>
  );
}

export default ImportantDocuments; 